import RelationshipBadge from "./RelationshipBadge";
import { firstVisible } from "../lib/visibility";

function getDisplayName(node) {
  if (!node) return "?";
  if (node.degree === 1) return node.profile?.full_name || "Unknown";
  if (node.degree === 2) {
    return node.profile?.full_name || "Unknown";
  }
  return "?";
}

function getSubtitle(node) {
  if (!node) return null;
  const p = node.profile;
  if (node.degree === 1) return firstVisible(p, ["role", "school"]);
  if (node.degree === 2) return firstVisible(p, ["role", "industry", "school"]);
  if (node.degree === 3) return firstVisible(p, ["industry", "role"]);
  return null;
}

function NodePill({ node, isYou, deg1Name }) {
  if (isYou) {
    return (
      <div className="path-node-pill you">
        <div className="path-node-name">You</div>
      </div>
    );
  }

  const name = getDisplayName(node);
  const subtitle = getSubtitle(node);

  return (
    <div className={`path-node-pill degree-${node?.degree}`}>
      <div className="path-node-name">{name}</div>
      {node?.degree === 1 && node?.relationshipType && (
        <RelationshipBadge type={node.relationshipType} />
      )}
      {node?.degree === 2 && deg1Name && (
        <div className="path-node-via">via {deg1Name}</div>
      )}
      {subtitle && <div className="path-node-subtitle">{subtitle}</div>}
    </div>
  );
}

export default function PathResultCard({ result, nodeMap, isHighlighted, onClick }) {
  const { path } = result;
  const deg1Node = nodeMap?.get(path[1]);
  const deg1Name = deg1Node?.profile?.full_name?.split(" ")[0] || "your connection";

  return (
    <div
      className={`path-result-card${isHighlighted ? " highlighted" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick?.()}
    >
      <div className="path-result-chain">
        {path.map((uid, i) => {
          const node = nodeMap?.get(uid);
          const isYou = i === 0;
          return (
            <span key={uid} style={{ display: "contents" }}>
              <NodePill
                node={node}
                isYou={isYou}
                deg1Name={i === 2 ? deg1Name : null}
              />
              {i < path.length - 1 && (
                <span className="path-chain-arrow">→</span>
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
}
